module.exports = __webpack_public_path__ + "static/media/logo_black_big.882579eb.png";